module.exports = __webpack_public_path__ + "img/Rank_07.f0ab5ca7.png";